import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Modal, Row, Spinner, Table } from 'react-bootstrap';

const ModalRegistrarFacturaComoGasto = ({
    show,
    onHide,
    idFacturaRecibida,
    onSuccess,
    onError
}) => {
    const { token, setToken, idUsuario } = useToken();
    const [guardandoGasto, setGuardandoGasto] = useState(false);
    const [errorGasto, setErrorGasto] = useState('');
    const [conceptosFactura, setConceptosFactura] = useState([]);
    const [cargandoConceptos, setCargandoConceptos] = useState(false);
    const [datosFactura, setDatosFactura] = useState({});
    const [editandoConcepto, setEditandoConcepto] = useState(null);
    const [tiposGasto, setTiposGasto] = useState([]);
    const [cargandoTiposGasto, setCargandoTiposGasto] = useState(false);
    const [tipoGastoSeleccionado, setTipoGastoSeleccionado] = useState('');
    const [formasPago, setFormasPago] = useState([]);
    const [cargandoFormasPago, setCargandoFormasPago] = useState(false);
    const [formaPagoSeleccionada, setFormaPagoSeleccionada] = useState('');
    const [usuarios, setUsuarios] = useState([]);
    const [cargandoUsuarios, setCargandoUsuarios] = useState(false);
    const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(idUsuario);
    const [cuentasBancarias, setCuentasBancarias] = useState([]);
    const [cargandoCuentas, setCargandoCuentas] = useState(false);
    const [cuentaBancariaSeleccionada, setCuentaBancariaSeleccionada] = useState('');

    /**
     * Utilidad para formatear números en formato mexicano
     */
    const formatNumberMX = (value) => {
        if (!value) return '0.00';
        return new Intl.NumberFormat('es-MX', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 4
        }).format(value);
    };

    /**
     * Función para obtener cuentas bancarias
     */
    const obtenerCuentasBancarias = async () => {
        setCargandoCuentas(true);
        try {
            const response = await fetch("/api/Gastos/obtenerCuentasBancarias", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                console.log('Respuesta obtenerCuentasBancarias:', data);

                if (data.iResponseType === 1) {
                    const ObjDetalles = JSON.parse(data.detalles);
                    const cuentas = ObjDetalles.table2 || [];
                    setCuentasBancarias(cuentas);
                    
                    // Seleccionar la primera cuenta automáticamente
                    if (cuentas.length > 0 && cuentas[0].idCatCuentaBancaria) {
                        setCuentaBancariaSeleccionada(cuentas[0].idCatCuentaBancaria.toString());
                    }
                } else {
                    console.warn('Respuesta no exitosa:', data);
                    setCuentasBancarias([]);
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    window.location.href = "";
                    return;
                }
                console.error('Error en la respuesta:', response.status);
                setCuentasBancarias([]);
            }
        } catch (error) {
            console.error('Error al obtener cuentas bancarias:', error);
            setCuentasBancarias([]);
        } finally {
            setCargandoCuentas(false);
        }
    };

    /**
     * Función para obtener usuarios
     */
    const obtenerUsuarios = async () => {
        setCargandoUsuarios(true);
        try {
            const response = await fetch("/api/Gastos/obtenerResponsableGasto", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                console.log('Respuesta obtenerUsuarios:', data);

                if (data.iResponseType === 1) {
                    const ObjDetalles = JSON.parse(data.detalles);
                    setUsuarios(ObjDetalles.table2 || []);
                } else {
                    console.warn('Respuesta no exitosa:', data);
                    setUsuarios([]);
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    window.location.href = "";
                    return;
                }
                console.error('Error en la respuesta:', response.status);
                setUsuarios([]);
            }
        } catch (error) {
            console.error('Error al obtener usuarios:', error);
            setUsuarios([]);
        } finally {
            setCargandoUsuarios(false);
        }
    };

    /**
     * Función para obtener formas de pago
     */
    const obtenerFormasPago = async () => {
        setCargandoFormasPago(true);
        try {
            const response = await fetch("/api/Gastos/obtenerFormasDePago", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                console.log('Respuesta obtenerFormasDePago:', data);

                if (data.iResponseType === 1) {
                    const ObjDetalles = JSON.parse(data.detalles);

                    setFormasPago(ObjDetalles.table2);
                } else {
                    console.warn('Respuesta no exitosa:', data);
                    setFormasPago([]);
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    window.location.href = "";
                    return;
                }
                console.error('Error en la respuesta:', response.status);
                setFormasPago([]);
            }
        } catch (error) {
            console.error('Error al obtener formas de pago:', error);
            setFormasPago([]);
        } finally {
            setCargandoFormasPago(false);
        }
    };

    /**
     * Función para obtener tipos de gasto
     */
    const obtenerTiposGasto = async () => {
        setCargandoTiposGasto(true);
        try {
            const response = await fetch("/api/Gastos/obtenerTipoDeGasto", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();

                if (data.iResponseType === 1) {
                    const ObjDetalles = JSON.parse(data.detalles);
                    setTiposGasto(ObjDetalles.table2 || []);
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    window.location.href = "";
                    return;
                }
            }
        } catch (error) {
            console.error('Error al obtener tipos de gasto:', error);
        } finally {
            setCargandoTiposGasto(false);
        }
    };

    /**
     * Función para obtener los conceptos de la factura
     */
    const obtenerConceptosFactura = async () => {
        if (!idFacturaRecibida) return;

        setCargandoConceptos(true);
        try {
            const objDataSend = {
                idFacturaRecibida: idFacturaRecibida
            };

            const response = await fetch("/api/contabilidad/centro-xml/FacturasRecibidas/obtenerXMLFacturaRecibida", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(objDataSend)
            });

            if (response.ok) {
                const data = await response.json();

                if (data.iResponseType === 1) {
                    const ObjDetalles = JSON.parse(data.detalles);
                    const vXMLString = ObjDetalles.table2[0].vXML;
                    const vXML = JSON.parse(vXMLString);

                    const conceptos = vXML.Comprobante.Conceptos.Concepto;
                    const comprobante = vXML.Comprobante;

                    // Si es un solo concepto, convertirlo a array
                    const conceptosArray = Array.isArray(conceptos) ? conceptos : [conceptos];

                    // Agregar propiedad editable a cada concepto
                    const conceptosConEdicion = conceptosArray.map(concepto => ({
                        ...concepto,
                        DescripcionEditable: concepto.Descripcion
                    }));

                    setConceptosFactura(conceptosConEdicion);

                    // Buscar el idCatFormaPago correspondiente a la clave
                    const formaPagoClave = comprobante.FormaPago;

                    setDatosFactura({
                        serie: comprobante.Serie,
                        folio: comprobante.Folio,
                        total: comprobante.Total,
                        moneda: comprobante.Moneda,
                        subtotal: comprobante.SubTotal,
                        formaPagoClave: formaPagoClave,
                        fechaEmision: comprobante.Fecha,
                        tipoCambio: comprobante.TipoCambio || '1.00'
                    });
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    window.location.href = "";
                    return;
                }
            }
        } catch (error) {
            console.error('Error al obtener conceptos:', error);
        } finally {
            setCargandoConceptos(false);
        }
    };

    /**
     * Efecto para cargar datos cuando se muestra el modal
     */
    useEffect(() => {
        if (show && idFacturaRecibida) {
            obtenerConceptosFactura();
            obtenerTiposGasto();
            obtenerFormasPago();
            obtenerUsuarios();
            obtenerCuentasBancarias();
        }
    }, [show, idFacturaRecibida]);

    /**
     * Efecto para establecer la forma de pago seleccionada cuando se cargan las formas de pago
     */
    useEffect(() => {
        if (Array.isArray(formasPago) && formasPago.length > 0 && datosFactura.formaPagoClave) {
            console.log('Buscando forma de pago para clave:', datosFactura.formaPagoClave);
            console.log('Formas de pago disponibles:', formasPago);

            // Buscar la forma de pago que coincida con la clave
            const formaPago = formasPago.find(fp => {
                // Comparar sin importar mayúsculas/minúsculas y espacios
                const claveFormaPago = fp.vClave?.toString().trim().toUpperCase();
                const claveFactura = datosFactura.formaPagoClave?.toString().trim().toUpperCase();

                console.log(`Comparando: "${claveFormaPago}" === "${claveFactura}"`);

                return claveFormaPago === claveFactura;
            });

            if (formaPago) {
                console.log('Forma de pago encontrada:', formaPago);
                setFormaPagoSeleccionada(formaPago.idCatFormaPago.toString());
            } else {
                console.warn('No se encontró forma de pago para la clave:', datosFactura.formaPagoClave);
                // Si no se encuentra, dejar vacío para que el usuario seleccione
                setFormaPagoSeleccionada('');
            }
        }
    }, [formasPago, datosFactura.formaPagoClave]);

    /**
     * Función para limpiar el modal
     */
    const limpiarModal = () => {
        setErrorGasto('');
        setGuardandoGasto(false);
        setConceptosFactura([]);
        setDatosFactura({});
        setEditandoConcepto(null);
        setTipoGastoSeleccionado('');
        setFormaPagoSeleccionada('');
        setUsuarioSeleccionado('');
        setCuentaBancariaSeleccionada('');
    };

    /**
     * Función para cerrar el modal
     */
    const handleClose = () => {
        if (!guardandoGasto) {
            limpiarModal();
            onHide();
        }
    };

    /**
     * Función para iniciar edición de un concepto
     */
    const handleEditarConcepto = (index) => {
        setEditandoConcepto(index);
    };

    /**
     * Función para cancelar edición de un concepto
     */
    const handleCancelarEdicion = (index) => {
        // Restaurar descripción original
        const nuevosConceptos = [...conceptosFactura];
        nuevosConceptos[index].DescripcionEditable = nuevosConceptos[index].Descripcion;
        setConceptosFactura(nuevosConceptos);
        setEditandoConcepto(null);
    };

    /**
     * Función para guardar edición de un concepto
     */
    const handleGuardarEdicion = () => {
        setEditandoConcepto(null);
    };

    /**
     * Función para manejar cambios en la descripción de un concepto
     */
    const handleDescripcionChange = (index, value) => {
        const nuevosConceptos = [...conceptosFactura];
        nuevosConceptos[index].DescripcionEditable = value.toUpperCase();
        setConceptosFactura(nuevosConceptos);

        // Limpiar error si existe
        if (errorGasto) {
            setErrorGasto('');
        }
    };

    /**
     * Función para validar que todos los conceptos tengan descripción
     */
    const validarConceptos = () => {
        const conceptosSinDescripcion = conceptosFactura.filter(
            c => !c.DescripcionEditable || !c.DescripcionEditable.trim()
        );

        if (conceptosSinDescripcion.length > 0) {
            setErrorGasto('Todos los conceptos deben tener una descripción');
            return false;
        }

        if (!tipoGastoSeleccionado) {
            setErrorGasto('Debe seleccionar un tipo de gasto');
            return false;
        }

        if (!formaPagoSeleccionada) {
            setErrorGasto('Debe seleccionar una forma de pago');
            return false;
        }

        if (!usuarioSeleccionado) {
            setErrorGasto('Debe seleccionar un usuario');
            return false;
        }

        if (!cuentaBancariaSeleccionada) {
            setErrorGasto('Debe seleccionar una cuenta bancaria');
            return false;
        }

        return true;
    };

    /**
     * Función para registrar la factura como gasto
     */
    const handleRegistrarGasto = async () => {
        // Validar descripciones
        if (!validarConceptos()) {
            return;
        }

        setGuardandoGasto(true);
        setErrorGasto('');

        try {
            // Preparar conceptos con todos los campos necesarios
            const conceptosCompletos = conceptosFactura.map(c => {
                // Calcular todos los impuestos del concepto
                let iva = 0;
                let ieps = 0;
                let ivaRetenido = 0;
                let isrRetenido = 0;
                let iepsRetenido = 0;
                let tasaOCuota = 0;
                let tipoFactor = '';

                // Procesar TRASLADOS (IVA, ISR, IEPS)
                if (c.Impuestos?.Traslados?.Traslado) {
                    const traslados = Array.isArray(c.Impuestos.Traslados.Traslado)
                        ? c.Impuestos.Traslados.Traslado
                        : [c.Impuestos.Traslados.Traslado];

                    traslados.forEach(traslado => {
                        const impuesto = traslado.Impuesto;
                        const importe = parseFloat(traslado.Importe || 0);

                        if (impuesto === '002') { // IVA Trasladado
                            iva += importe;
                            tasaOCuota = parseFloat(traslado.TasaOCuota || 0);
                            tipoFactor = traslado.TipoFactor || '';
                        } else if (impuesto === '003') { // IEPS Trasladado
                            ieps += importe;
                        }
                    });
                }

                // Procesar RETENCIONES (IVA Retenido, ISR Retenido, IEPS Retenido)
                if (c.Impuestos?.Retenciones?.Retencion) {
                    const retenciones = Array.isArray(c.Impuestos.Retenciones.Retencion)
                        ? c.Impuestos.Retenciones.Retencion
                        : [c.Impuestos.Retenciones.Retencion];

                    retenciones.forEach(retencion => {
                        const impuesto = retencion.Impuesto;
                        const importe = parseFloat(retencion.Importe || 0);

                        if (impuesto === '002') { // IVA Retenido
                            ivaRetenido += importe;
                        } else if (impuesto === '001') { // ISR Retenido
                            isrRetenido += importe;
                        } else if (impuesto === '003') { // IEPS Retenido
                            iepsRetenido += importe;
                        }
                    });
                }

                const cantidad = parseFloat(c.Cantidad || 0);
                const valorUnitario = parseFloat(c.ValorUnitario || 0);
                const importe = parseFloat(c.Importe || 0);
                const descuento = parseFloat(c.Descuento || 0);

                // Calcular total: Importe + Traslados - Descuento - Retenciones
                const total = importe - descuento + iva + ieps - ivaRetenido - isrRetenido - iepsRetenido;

                return {
                    descripcion: c.DescripcionEditable.trim(),
                    cantidad: cantidad,
                    valorUnitario: valorUnitario,
                    importe: importe,
                    descuento: descuento,
                    // Traslados
                    iva: iva,
                    ieps: ieps,
                    // Retenciones
                    ivaRetenido: ivaRetenido,
                    isrRetenido: isrRetenido,
                    iepsRetenido: iepsRetenido,
                    total: total,
                    claveProdServ: c.ClaveProdServ || '',
                    claveUnidad: c.ClaveUnidad || '',
                    noIdentificacion: c.NoIdentificacion || '',
                    tasaOCuota: tasaOCuota,
                    tipoFactor: tipoFactor
                };
            });

            const data = {
                idFacturaRecibida: idFacturaRecibida,
                idTipoGasto: tipoGastoSeleccionado,
                conceptos: conceptosCompletos,
                total: parseFloat(datosFactura.total || 0),
                moneda: datosFactura.moneda || 'MXN',
                tipoCambio: parseFloat(datosFactura.tipoCambio || 1),
                idCatFormaPago: parseInt(formaPagoSeleccionada),
                fechaEmision: datosFactura.fechaEmision || '',
                idUsuario: parseInt(usuarioSeleccionado),
                idCatCuentaBancaria: parseInt(cuentaBancariaSeleccionada)
            };

            const response = await fetch("/api/Gastos/RegistrarGastoDesdeFactura", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });

            if (response.ok) {
                const result = await response.json();

                if (result.iResponseType === 1) {
                    limpiarModal();
                    onHide();
                    if (onSuccess) {
                        onSuccess(result.vMessage || 'Gasto registrado exitosamente');
                    }
                } else {
                    setErrorGasto(result.vMessage || 'Error al registrar el gasto');
                    if (onError) {
                        onError(result.vMessage || 'Error al registrar el gasto');
                    }
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    window.location.href = "";
                    return;
                }
                const errorMsg = `Error al registrar el gasto: ${response.status} ${response.statusText}`;
                setErrorGasto(errorMsg);
                if (onError) {
                    onError(errorMsg);
                }
            }
        } catch (error) {
            const errorMsg = 'Error al registrar el gasto: ' + error.message;
            setErrorGasto(errorMsg);
            if (onError) {
                onError(errorMsg);
            }
        } finally {
            setGuardandoGasto(false);
        }
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={!guardandoGasto}
            centered
            size="xl"
        >
            <Modal.Header closeButton={!guardandoGasto}>
                <Modal.Title>
                    Registrar Factura como Gasto
                    {datosFactura.serie && datosFactura.folio && (
                        <small className="ms-2 text-muted">
                            ({datosFactura.serie}-{datosFactura.folio})
                        </small>
                    )}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <Form>
                    {/* Mostrar error general si existe */}
                    {errorGasto && (
                        <div className="alert alert-danger mb-3">
                            <span style={{ fontSize: '1.2rem' }}>??</span> {errorGasto}
                        </div>
                    )}

                    {/* Datos de la Factura */}
                    <Card className="mb-3">
                        <Card.Header className="bg-info text-white">
                            <strong>Datos de la Factura</strong>
                        </Card.Header>
                        <Card.Body>
                            <Row>
                                <Col md={6} lg={4} className="mb-2">
                                    <Form.Group>
                                        <Form.Label className="mb-1">
                                            <small><strong>Usuario <span className="text-danger">*</span></strong></small>
                                        </Form.Label>
                                        {cargandoUsuarios ? (
                                            <div className="text-center">
                                                <Spinner animation="border" size="sm" />
                                            </div>
                                        ) : (
                                            <Form.Select
                                                size="sm"
                                                value={usuarioSeleccionado}
                                                onChange={(e) => {
                                                    setUsuarioSeleccionado(e.target.value);
                                                    if (errorGasto) setErrorGasto('');
                                                }}
                                                disabled={guardandoGasto}
                                                isInvalid={!usuarioSeleccionado && errorGasto}
                                            >
                                                <option value="">Seleccione...</option>
                                                {Array.isArray(usuarios) && usuarios.map((usuario) => (
                                                    <option key={usuario.idUsuario} value={usuario.idUsuario}>
                                                        {usuario.vNombre} {usuario.vApellidos}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col md={6} lg={4} className="mb-2">
                                    <Form.Group>
                                        <Form.Label className="mb-1">
                                            <small><strong>Forma de Pago <span className="text-danger">*</span></strong></small>
                                        </Form.Label>
                                        {cargandoFormasPago ? (
                                            <div className="text-center">
                                                <Spinner animation="border" size="sm" />
                                            </div>
                                        ) : (
                                            <Form.Select
                                                size="sm"
                                                value={formaPagoSeleccionada}
                                                onChange={(e) => {
                                                    setFormaPagoSeleccionada(e.target.value);
                                                    if (errorGasto) setErrorGasto('');
                                                }}
                                                disabled={guardandoGasto}
                                                isInvalid={!formaPagoSeleccionada && errorGasto}
                                            >
                                                <option value="">Seleccione...</option>
                                                {Array.isArray(formasPago) && formasPago.map((forma) => (
                                                    <option key={forma.idCatFormaPago} value={forma.idCatFormaPago}>
                                                        {forma.vClave} - {forma.vDescripcionFormaPago}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col md={12} lg={4} className="mb-2">
                                    <Form.Group>
                                        <Form.Label className="mb-1">
                                            <small><strong>Cuenta Bancaria <span className="text-danger">*</span></strong></small>
                                        </Form.Label>
                                        {cargandoCuentas ? (
                                            <div className="text-center">
                                                <Spinner animation="border" size="sm" />
                                            </div>
                                        ) : (
                                            <Form.Select
                                                size="sm"
                                                value={cuentaBancariaSeleccionada}
                                                onChange={(e) => {
                                                    setCuentaBancariaSeleccionada(e.target.value);
                                                    if (errorGasto) setErrorGasto('');
                                                }}
                                                disabled={guardandoGasto}
                                                isInvalid={!cuentaBancariaSeleccionada && errorGasto}
                                            >
                                                <option value="">Seleccione...</option>
                                                {Array.isArray(cuentasBancarias) && cuentasBancarias.map((cuenta) => (
                                                    <option key={cuenta.idCatCuentaBancaria} value={cuenta.idCatCuentaBancaria}>
                                                        {`${cuenta.vNumCta} - ${cuenta.vNombreBanco} - ${cuenta.vNombreTitular}`}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6} lg={3} className="mb-2">
                                    <Form.Group>
                                        <Form.Label className="mb-1">
                                            <small><strong>Fecha de Emisión</strong></small>
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={datosFactura.fechaEmision || ''}
                                            readOnly
                                            size="sm"
                                            className="bg-light"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6} lg={1} className="mb-2">
                                    <Form.Group>
                                        <Form.Label className="mb-1">
                                            <small><strong>Moneda</strong></small>
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={datosFactura.moneda || ''}
                                            readOnly
                                            size="sm"
                                            className="bg-light"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6} lg={2} className="mb-2">
                                    <Form.Group>
                                        <Form.Label className="mb-1">
                                            <small><strong>Tipo de Cambio</strong></small>
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={datosFactura.tipoCambio || '1.00'}
                                            readOnly
                                            size="sm"
                                            className="bg-light"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={12} lg={6} className="mb-2">
                                    <Form.Group>
                                        <Form.Label className="mb-1">
                                            <small><strong>Tipo de Gasto <span className="text-danger">*</span></strong></small>
                                        </Form.Label>
                                        {cargandoTiposGasto ? (
                                            <div className="text-center">
                                                <Spinner animation="border" size="sm" />
                                            </div>
                                        ) : (
                                            <Form.Select
                                                size="sm"
                                                value={tipoGastoSeleccionado}
                                                onChange={(e) => {
                                                    setTipoGastoSeleccionado(e.target.value);
                                                    if (errorGasto) setErrorGasto('');
                                                }}
                                                disabled={guardandoGasto}
                                                isInvalid={!tipoGastoSeleccionado && errorGasto}
                                            >
                                                <option value="">Seleccione...</option>
                                                {tiposGasto.map((tipo) => (
                                                    <option key={tipo.idTipoGasto} value={tipo.idTipoGasto}>
                                                        {tipo.vNombre}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>

                    {/* Conceptos de la Factura */}
                    <Card className="mb-3">
                        <Card.Header className="bg-primary text-white">
                            <strong>Conceptos de la Factura</strong>
                        </Card.Header>
                        <Card.Body className="p-0">
                            {cargandoConceptos ? (
                                <div className="text-center p-4">
                                    <Spinner animation="border" variant="primary" />
                                    <p className="mt-2 mb-0">Cargando conceptos...</p>
                                </div>
                            ) : conceptosFactura.length > 0 ? (
                                <div style={{ overflowX: 'auto' }}>
                                    <Table striped bordered hover size="sm" className="mb-0">
                                        <thead className="bg-light">
                                            <tr>
                                                <th className="text-center" style={{ minWidth: '80px' }}>Cantidad</th>
                                                <th className="text-center" style={{ minWidth: '100px' }}>Código SAT</th>
                                                <th className="text-center" style={{ minWidth: '80px' }}>Unidad</th>
                                                <th style={{ minWidth: '300px' }}>Descripción</th>
                                                <th className="text-end" style={{ minWidth: '100px' }}>Valor Unit.</th>
                                                <th className="text-end" style={{ minWidth: '100px' }}>Importe</th>
                                                <th className="text-center" style={{ minWidth: '90px' }}>Tasa/Cuota</th>
                                                <th className="text-end" style={{ minWidth: '100px' }}>IVA</th>
                                                <th className="text-end" style={{ minWidth: '100px' }}>IEPS</th>
                                                <th className="text-end" style={{ minWidth: '100px' }}>IVA Ret.</th>
                                                <th className="text-end" style={{ minWidth: '100px' }}>ISR Ret.</th>
                                                <th className="text-end" style={{ minWidth: '100px' }}>Descuento</th>
                                                <th className="text-end" style={{ minWidth: '100px' }}>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {conceptosFactura.map((concepto, index) => {
                                                const cantidad = parseFloat(concepto.Cantidad || 0);
                                                const valorUnitario = parseFloat(concepto.ValorUnitario || 0);
                                                const importe = parseFloat(concepto.Importe || 0);
                                                const descuento = parseFloat(concepto.Descuento || 0);

                                                // Calcular todos los impuestos
                                                let iva = 0;
                                                let ieps = 0;
                                                let tasaCuota = 0;

                                                // Traslados
                                                if (concepto.Impuestos?.Traslados?.Traslado) {
                                                    const traslados = Array.isArray(concepto.Impuestos.Traslados.Traslado)
                                                        ? concepto.Impuestos.Traslados.Traslado
                                                        : [concepto.Impuestos.Traslados.Traslado];

                                                    traslados.forEach(traslado => {
                                                        if (traslado.Impuesto === '002') { // IVA
                                                            iva += parseFloat(traslado.Importe || 0);
                                                            tasaCuota = parseFloat(traslado.TasaOCuota || 0);
                                                        } else if (traslado.Impuesto === '003') { // IEPS
                                                            ieps += parseFloat(traslado.Importe || 0);
                                                        }
                                                    });
                                                }

                                                // Retenciones
                                                let ivaRetenido = 0;
                                                let isrRetenido = 0;

                                                if (concepto.Impuestos?.Retenciones?.Retencion) {
                                                    const retenciones = Array.isArray(concepto.Impuestos.Retenciones.Retencion)
                                                        ? concepto.Impuestos.Retenciones.Retencion
                                                        : [concepto.Impuestos.Retenciones.Retencion];

                                                    retenciones.forEach(retencion => {
                                                        if (retencion.Impuesto === '002') { // IVA Retenido
                                                            ivaRetenido += parseFloat(retencion.Importe || 0);
                                                        } else if (retencion.Impuesto === '001') { // ISR Retenido
                                                            isrRetenido += parseFloat(retencion.Importe || 0);
                                                        }
                                                    });
                                                }

                                                const total = importe + iva + ieps - descuento - ivaRetenido - isrRetenido;
                                                const estaEditando = editandoConcepto === index;

                                                return (
                                                    <tr key={index}>
                                                        <td className="text-center">{formatNumberMX(cantidad)}</td>
                                                        <td className="text-center">
                                                            <small>{concepto.ClaveProdServ}</small>
                                                        </td>
                                                        <td className="text-center">
                                                            <small>{concepto.ClaveUnidad}</small>
                                                        </td>
                                                        <td>
                                                            {estaEditando ? (
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <Form.Control
                                                                        as="textarea"
                                                                        rows={2}
                                                                        value={concepto.DescripcionEditable}
                                                                        onChange={(e) => handleDescripcionChange(index, e.target.value)}
                                                                        style={{ fontSize: '0.875rem', flex: 1 }}
                                                                        maxLength={500}
                                                                        autoFocus
                                                                    />
                                                                    <div className="d-flex flex-column gap-1">
                                                                        <Button
                                                                            variant="success"
                                                                            size="sm"
                                                                            onClick={() => handleGuardarEdicion()}
                                                                            title="Guardar"
                                                                            style={{ padding: '0.25rem 0.5rem', fontSize: '0.875rem' }}
                                                                        >
                                                                            ✔️
                                                                        </Button>
                                                                        <Button
                                                                            variant="secondary"
                                                                            size="sm"
                                                                            onClick={() => handleCancelarEdicion(index)}
                                                                            title="Cancelar"
                                                                            style={{ padding: '0.25rem 0.5rem', fontSize: '0.875rem' }}
                                                                        >
                                                                            ✖️
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="d-flex align-items-center justify-content-between gap-2">
                                                                    <small style={{ flex: 1 }}>{concepto.DescripcionEditable}</small>
                                                                    <span
                                                                        onClick={() => !guardandoGasto && handleEditarConcepto(index)}
                                                                        title="Editar descripción"
                                                                        style={{
                                                                            cursor: guardandoGasto ? 'not-allowed' : 'pointer',
                                                                            fontSize: '1.2rem',
                                                                            opacity: guardandoGasto ? 0.5 : 1,
                                                                            color: '#0d6efd',
                                                                            userSelect: 'none'
                                                                        }}
                                                                    >
                                                                        ✏️
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </td>
                                                        <td className="text-end">
                                                            ${formatNumberMX(valorUnitario)}
                                                        </td>
                                                        <td className="text-end">
                                                            ${formatNumberMX(importe)}
                                                        </td>
                                                        <td className="text-center">
                                                            <small>{formatNumberMX(tasaCuota)}</small>
                                                        </td>
                                                        <td className="text-end">
                                                            {iva > 0 ? `$${formatNumberMX(iva)}` : '-'}
                                                        </td>
                                                        <td className="text-end">
                                                            {ieps > 0 ? `$${formatNumberMX(ieps)}` : '-'}
                                                        </td>
                                                        <td className="text-end">
                                                            {ivaRetenido > 0 ? `$${formatNumberMX(ivaRetenido)}` : '-'}
                                                        </td>
                                                        <td className="text-end">
                                                            {isrRetenido > 0 ? `$${formatNumberMX(isrRetenido)}` : '-'}
                                                        </td>
                                                        <td className="text-end">
                                                            {descuento > 0 ? `$${formatNumberMX(descuento)}` : '-'}
                                                        </td>
                                                        <td className="text-end">
                                                            <strong>${formatNumberMX(total)}</strong>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                        {datosFactura.total && (
                                            <tfoot className="bg-light">
                                                <tr>
                                                    <td colSpan="12" className="text-end">
                                                        <strong>Total Factura ({datosFactura.moneda}):</strong>
                                                    </td>
                                                    <td className="text-end">
                                                        <strong className="text-primary">
                                                            ${formatNumberMX(datosFactura.total)}
                                                        </strong>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        )}
                                    </Table>
                                </div>
                            ) : (
                                <div className="text-center p-4 text-muted">
                                    <div style={{ fontSize: '3rem' }}>📄</div>
                                    <p className="mb-0">No se encontraron conceptos para esta factura</p>
                                </div>
                            )}
                        </Card.Body>
                    </Card>

                    <div className="alert alert-info mb-0">
                        <small>
                            <span style={{ fontSize: '1rem' }}>ℹ️</span> Haga clic en el icono ✏️ para editar la descripción de un concepto si es necesario.
                        </small>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={handleClose}
                    disabled={guardandoGasto}
                >
                    Cancelar
                </Button>
                <Button
                    variant="primary"
                    onClick={handleRegistrarGasto}
                    disabled={guardandoGasto || conceptosFactura.length === 0 || !tipoGastoSeleccionado || !formaPagoSeleccionada || !usuarioSeleccionado || !cuentaBancariaSeleccionada}
                >
                    {guardandoGasto ? (
                        <>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className="me-2"
                            />
                            Registrando...
                        </>
                    ) : (
                        <>
                            <span className="me-2">💾</span>
                            Registrar Gasto
                        </>
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

ModalRegistrarFacturaComoGasto.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    idFacturaRecibida: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]).isRequired,
    onSuccess: PropTypes.func,
    onError: PropTypes.func
};

export default ModalRegistrarFacturaComoGasto;